<div fxLayout="row" fxLayout.xs="column" [fxLayoutAlign]="align" class="text-muted">
    <div *ngIf="product?.productQuantity > 0 && (type=='all' || type=='wish')">
        <bdi>
            <span *ngIf="type!='wish'" class="fw-500">Количество:</span> 
            <button mat-icon-button matTooltip="Убрать" (click)="decrementProductCartCount()"><mat-icon>remove</mat-icon></button>
            <span> {{count}} </span>
            <button mat-icon-button matTooltip="Добавить" (click)="incrementProductCartCount()"><mat-icon>add</mat-icon></button>
        </bdi>
    </div>
    <div *ngIf="type!='wish'">
        <button mat-icon-button matTooltip="Добавить в Корзину" *ngIf="product?.productQuantity > 0" (click)="addToCart()"><mat-icon>shopping_cart</mat-icon></button>
        <button *ngIf="type!='all'" mat-icon-button matTooltip="Просмотр" (click)="openProductDialog(product)"><mat-icon>remove_red_eye</mat-icon></button>
    </div>
</div> 
<div *ngIf="product?.productQuantity == 0 && type=='all'" class="bg-warn p-1 mt-2">
    К сожалению товара нет в наличии.
</div>
